import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'td-wb-linear-list-item-label',
  template: '<ng-content />',
  styleUrls: ['linear-list-item-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    'role': 'rowheader'
  }
})
export class LinearListItemLabelComponent {
}
